import { Inbox, Layers, PenTool, Target, Twitch } from 'react-feather';
import {
  AiOutlineControl,
  AiOutlineBarChart,
  AiOutlineSchedule,
  AiFillCrown,
} from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import {
  MdOutlineToday,
  MdOutlineEventAvailable,
  MdOutlineNotificationsNone,
  MdOutlineRoom,
  MdOutlineVideoCameraFront,
  MdOutlineAssignment,
  MdOutlineBadge,
  MdOutlineLibraryBooks,
  MdPersonOutline,
  MdImportExport,
  MdOutlineCategory,
  MdControlCamera,
  MdOutlineEditNote,
  MdOutlineGroup,
  MdOutlineManageAccounts,
  MdOutlineSettingsApplications,
  MdOutlinePendingActions,
  MdOutlineAnnouncement,
  MdOutlineSwitchAccount,
  MdOutlineAssessment,
  MdOutlineSettings,
  MdOutlineBackupTable,
  MdOutlineCardMembership,
  MdOutlineMonitor,
  MdOutlineNoteAlt,
  MdOutlineRoomPreferences,
  MdOutlineBusinessCenter,
  MdLocationSearching,
  MdOutlineTravelExplore,
  MdOutlinePsychology,
  MdOutlineClass,
  MdOutlineSupervisorAccount,
  MdOutlineEditNotifications,
  MdDoNotDisturbOnTotalSilence,
  MdOutlineAutoGraph,
  MdOutlineGroups,
} from 'react-icons/md';

import {
  RiBankCardLine,
  RiUserSettingsLine,
  RiFileList2Line,
  RiFileUserLine,
} from 'react-icons/ri';

import {
  TbCalendarTime,
  TbFileCheck,
  TbFileTime,
  TbHeartRateMonitor,
} from 'react-icons/tb';
import { AiOutlineCrown } from 'react-icons/ai';
import { GoPackage } from 'react-icons/go';

import { MdOutlineIndeterminateCheckBox } from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';
import { BsPersonCheck } from 'react-icons/bs';

export const userRoutePath = [
  '/users',
  '/users/create',
  '/users/edit',
  '/users/[id]/edit',
];
export const usertypeRoutePath = [
  '/user-types',
  '/user-types/create',
  '/user-types/[id]/edit',
];
export const userGroupRoutePath = [
  '/group',
  '/group/create',
  '/group/[id]/edit',
];
export const courseGridRoutePath = [
  '/course/courseGrid',
  '/course/create',
  '/course/[slug]/edit',
];
export const intakeRoutePath = [
  '/intakes',
  '/intakes/create',
  '/intakes/[slug]',
  '/intakes/intakeGrid',
  '/intakes/intake-grid',
  '/homes/intake',
  '/homes/intake/intakeGridcard',
];

export const intakeApprovalRoutePath = [
  '/intake/approval',
  '/intake/approval/[intakeId]',
];

export const resourceMasterRoutePath = [
  '/master/resource',
  '/master/resource/create',
  '/master/resource/[resourceId]',
];

export const locationMasterRoutePath = [
  '/master/location',
  '/master/location/create',
  '/master/location/[locationId]',
];
export const reportCompetencyRoutePath = [
  '/reports/competency',
  '/reports/competency/[userId]',
  '/reports/competency/isLearner',
];
export const competencyMasteryLevelsRoutePath = [
  '/master/competency-mastery-levels',
  '/master/competency-mastery-levels/[masterLevelId]',
];
export const competencyLevelsRoutePath = [
  '/master/competency-level',
  '/master/competency-level/create',
  '/master/competency-level/[competencyLevelId]',
];

export const coreCompetenciesRoutePath = [
  '/master/core-competencies',
  '/master/core-competencies/create',
  '/master/core-competencies/[competencyId]',
];

export const greatBookRoutePath = [
  '/intake/great-book',
  '/intake/great-book/create',
  '/intake/great-book/[intakeId]',
];

export const asynchronousAttendanceRoutePath = [
  '/reports/asynchronous-attendance',
];

export const homeRoutePath = ['/lms-user/home', '/home', '/homeCms'];
export const dashboardRoutePath = ['/'];
export const courseRoutePath = [
  '/course',
  '/course/courseGrid',
  '/course/create',
  '/homes/course',
];
export const workshopRouthPath = [
  '/homes/workshop',
  '/homes/workshop/view',
  '/course/[slug]/course-workshop',
  '/course/[slug]/course-ws-create',
  '/course/[slug]/course-ws-view',
  '/course/[slug]/course-ws-edit',
  '/workshop',
  '/workshop/create',
  '/workshop/view',
  '/workshop/edit',
  '/workshop/workshopCard',
];
export const centerRouthPath = [
  '/centre',
  '/centre/addcentre',
  '/centre/addcentres',
  '/centre/editCentre',
];
export const categoryRouthPath = [
  '/category',
  '/category/create',
  '/category/[id]/edit',
];
export const cmsPagesRouthPath = [
  '/lms-user/cmsBlog',
  '/lms-user/cmsBlog/testimonial',
  '/lms-user/cmsBlog/edit',
  '/lms-user/cmsBlog/view',
];
export const myTimesheetRouthPath = [
  '/timesheet/mytimesheet',
  '/timesheet/mytimesheet/view',
  '/timesheet/mytimesheet/addbank',
];
export const scheduleRouthPath = [
  '/timesheet/schedule',
  '/timesheet/schedule/addschedule',
  '/timesheet/schedule/view',
  '/timesheet/schedule/editschedule',
  '/timesheet/schedule/calenderview',
];
export const myScheduleRouthPath = [
  '/timesheet/myschedule',
  '/timesheet/myschedule/view',
];
export const approveRouthPath = [
  '/timesheet/approve',
  '/timesheet/approve/view',
  '/timesheet/approve/edit',
];
export const manageTimesheetRouthPath = [
  '/timesheet/managetimesheet',
  '/timesheet/managetimesheet/edit',
  '/timesheet/managetimesheet/view',
  '/timesheet/addtimesheet',
  '/timesheet/addtimesheet/view',
];
export const notificationRouthPath = [
  '/notification',
  '/notification/[id]/edit',
  '/notification/create',
  '/notification/history',
];
export const announcementRouthPath = [
  '/announcement',
  '/announcement/view',
  '/announcement/create',
];
export const reminderRouthPath = ['/reminder', '/reminder/create'];
// export const businessRulesRouthPath = [
//   '/business-rules',
//   '/business-rules/[businessRuleId]',
// ];
export const badgeRouthPath = [
  '/Badge',
  '/Badge/create',
  '/Badge/badge',
  '/Badge/create/addType',
  '/Badge/modalBadges',
];
export const learningRouthPath = [
  '/learning-path',
  '/learning-path/[learningPathId]',
];
export const staffRequestRouthPath = [
  '/staff-request',
  '/staff-request/[staffRequestId]',
  '/staff-request/[staffRequestId]/edit',
  '/staff-request/[staffRequestId]/view',
];
export const manageStaffRequestRouthPath = [
  '/manage-staff-request',
  '/manage-staff-request/[manageStaffRequestId]',
  '/manage-staff-request/[manageStaffRequestId]/view',
];
export const certificateRouthPath = [
  '/certificate',
  '/certificate/template-create',
  '/certificate/template-create/[id]/generateCertificate',
  '/course/[slug]/certificate',
  '/certificate/userCertificate',
];
export const userReportRouthPath = ['/reports/users', '/reports/users/[id]'];
export const courseReportRouthPath = [
  '/reports/courses',
  '/reports/courses/[slug]',
];
export const reportOverviewRouthPath = ['/reports'];
export const testReportRouthPath = ['/reports/tests', '/reports/tests/[id]'];
export const liveReportRouthPath = [
  '/reports/liveClass',
  '/reports/liveClass/[id]',
];
export const liveReportScheduleRouthPath = [
  '/reports/calandar',
  '/reports/calandar/[id]',
];
export const attendanceRouthPath = [
  '/reports/attendance',
  '/reports/attendance/[id]',
];
export const surveyReportRouthPath = [
  '/reports/surveys',
  '/reports/surveys/[id]',
];
export const assignmentReportRouthPath = [
  '/reports/assignments',
  '/reports/assignments/[id]',
];
export const scormReportRouthPath = ['/reports/scorm', '/reports/scorm/[id]'];

export const StaffTypeReportRouthPath = [
  '/reports/staffType',
  '/reports/staffType/[id]',
];
export const greatBookReportRouthPath = [
  '/reports/great-book/intake-report',
  '/reports/great-book/global-report',
];
export const demeritPointsRouthPath = [
  '/reports/demeritPoints',
  '/reports/demeritPoints/demeritGlobal',
  '/reports/demeritPoints/detailDemeritUser',
];
export const creditsPointsRouthPath = [
  '/reports/credits',
  '/reports/credits/creditsGlobal',
  '/reports/credits/creditsGlobalList',
];

export const learningReportRouthPath = [
  '/reports/learning-path',
  '/reports/learning-path/[learningPathId]',
];
export const certificateReportRouthPath = ['/certificate/certificateReport'];
export const myLearningPath = ['/homes/myLearning'];
export const settingsPath = ['/account-settings'];
export const importExportPath = ['/import-export'];
export const cmsSettingPath = ['/manageCmsBlog'];
export const systemLogPath = ['/system-log'];
export const monitoringPath = ['/monitoring'];
export const liveSessionPath = ['/live-sessions'];
export const zoomPath = ['/zoom'];
export const locationPath = ['/location'];
export const orgroutePath = [
  '/master/organization/create',
  '/master/organization',
];
export const centreTypePath = [
  '/master/centreType',
  '/master/centreType/create',
];

export const businessPath = [
  '/master/businessType/create',
  '/master/businessType',
];
export const centrePath = ['/master/centres/create', '/master/centres'];
export const pointsPath = ['/master/points', '/master/points/create'];
export const demeritPath = ['/master/demerit', '/master/demerit/create'];
export const demeritTypePath = [
  '/master/demeritType',
  '/master/demeritType/create',
];
export const staffTypePath = ['/master/staffType', '/master/staffType/create'];
export const manageStaffTypePath = [
  '/master/manageStaffType',
  '/master/manageStaffType/create',
];
export const contentApprovalPath = [
  '/master/contentApproval',
  '/master/contentApproval/listPage',
];

export const stackableCourseRoutePath = [
  '/stackable-course',
  '/stackable-course/[stackableId]',
];

export const reportStackableRoutePath = [
  '/reports/stackable',
  '/reports/stackable/[stackId]',
];

// --- ROUTES END --- //

import { USER_METHODS, USER_ROLES } from './constants';
import { BiBriefcase } from 'react-icons/bi';

export const userAccessType = {
  stackableCourse: [
    [USER_METHODS.GET, 'stackable-course'],
    [USER_METHODS.GET, 'stackable-course/:id'],
  ],

  user: [
    [USER_METHODS.POST, 'users'],
    [USER_METHODS.GET, 'users'],
    [USER_METHODS.PUT, 'users/:id'],
    [USER_METHODS.DELETE, 'users/:id'],
  ],
  userType: [
    [USER_METHODS.POST, 'user-types'],
    [USER_METHODS.GET, 'user-types'],
    [USER_METHODS.PUT, 'user-types/:id'],
    [USER_METHODS.DELETE, 'user-types/:id'],
  ],
  userGroups: [
    [USER_METHODS.POST, 'course-groups'],
    [USER_METHODS.GET, 'course-groups'],
    [USER_METHODS.PUT, 'course-groups/:id'],
    [USER_METHODS.DELETE, 'course-groups/:id'],
  ],
  course: [
    [USER_METHODS.POST, 'courses'],
    [USER_METHODS.GET, 'courses'],
    [USER_METHODS.PUT, 'courses/:id'],
    [USER_METHODS.DELETE, 'courses/:id'],
  ],
  classes: [
    [USER_METHODS.POST, 'intakes'],
    [USER_METHODS.GET, 'intakes'],
  ],
  contentApproval: [
    [USER_METHODS.GET, 'get-content-review-units-by-centre'],
    [USER_METHODS.PUT, 'units/:id'],
    [USER_METHODS.DELETE, 'units/:id'],
  ],
  categories: [
    [USER_METHODS.POST, 'categories'],
    [USER_METHODS.PUT, 'categories/:id'],
    [USER_METHODS.DELETE, 'categories/:id'],
  ],
  importExport: [
    [USER_METHODS.POST, 'users/import'],
    [USER_METHODS.PUT, 'users/export'],
  ],
  certificate: [
    [USER_METHODS.POST, 'certificates'],
    [USER_METHODS.GET, 'certificates'],
    [USER_METHODS.PUT, 'certificates/:id'],
    [USER_METHODS.DELETE, 'certificates/:id'],
  ],
  badge: [
    [USER_METHODS.POST, 'badges'],
    [USER_METHODS.GET, 'badges'],
    [USER_METHODS.PUT, 'badges/:id'],
    [USER_METHODS.DELETE, 'badges/:id'],
  ],
  staffRequest: [
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
    [USER_METHODS.PUT, 'staff-request/:id'],
    [USER_METHODS.GET, 'staff-request/:id'],
    [USER_METHODS.POST, 'staff-request/'],
  ],
  staffType: [
    [USER_METHODS.POST, 'staff-type/'],
    [USER_METHODS.PUT, 'staff-type/:id'],
    [USER_METHODS.GET, 'staff-type/get-staff-types'],
    [USER_METHODS.POST, 'staff-type/get-staff-types'],
    [USER_METHODS.GET, 'staff-type/get-staff-type/:id'],
  ],
  manageStaffRequest: [
    [USER_METHODS.GET, 'manageStaffRequest/staff-request/get-staff-requests'],
    [USER_METHODS.POST, 'manageStaffRequest/staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'manageStaffRequest/staff-request/:id'],
    [USER_METHODS.PUT, 'manageStaffRequest/staff-request/approval/:id'],
  ],
  learningPath: [
    [USER_METHODS.POST, 'learning-path'],
    [USER_METHODS.PUT, 'learning-path/:id'],
    [USER_METHODS.POST, 'learning-path/learning-path-enrollment'],
    [USER_METHODS.GET, 'learning-path/:id'],
    [USER_METHODS.GET, 'learning-path/get-user-learning-path'],
  ],

  resourceMaster: [
    // [USER_METHODS.POST, 'resources'],
    // [USER_METHODS.GET, 'resources'],
    // [USER_METHODS.PUT, 'resources/:id'],
    // [USER_METHODS.DELETE, 'resources/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  locationMaster: [
    // [USER_METHODS.POST, 'locations'],
    // [USER_METHODS.GET, 'locations'],
    // [USER_METHODS.PUT, 'locations/:id'],
    // [USER_METHODS.DELETE, 'locations/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  competencyMasteryLevels: [
    // [USER_METHODS.POST, 'competency/mastery-levels'],
    // [USER_METHODS.GET, 'competency/mastery-levels'],
    // [USER_METHODS.PUT, 'competency/mastery-levels/:id'],
    // [USER_METHODS.DELETE, 'competency/mastery-levels/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  competencyLevels: [
    // [USER_METHODS.POST, 'competency/mastery-levels'],
    // [USER_METHODS.GET, 'competency/mastery-levels'],
    // [USER_METHODS.PUT, 'competency/mastery-levels/:id'],
    // [USER_METHODS.DELETE, 'competency/mastery-levels/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  coreCompetencies: [
    // [USER_METHODS.POST, 'competency/core'],
    // [USER_METHODS.GET, 'competency/core'],
    // [USER_METHODS.PUT, 'competency/core/:id'],
    // [USER_METHODS.DELETE, 'competency/core/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  greatBook: [
    // [USER_METHODS.POST, 'great-book'],
    // [USER_METHODS.GET, 'great-book'],
    // [USER_METHODS.PUT, 'great-book/:id'],
    // [USER_METHODS.DELETE, 'great-book/:id'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],
  asynchronousAttendance: [
    // [USER_METHODS.GET, 'reports/asynchronous-attendance'],
    [USER_METHODS.POST, 'staff-request/get-staff-requests'],
    [USER_METHODS.GET, 'staff-request/get-staff-requests'],
  ],

  cmsSettings: [[USER_METHODS.GET, 'cms-settings']],
  cmsPages: [
    [USER_METHODS.POST, 'content-pages'],
    [USER_METHODS.GET, 'content-pages'],
    [USER_METHODS.PUT, 'content-pages/:id'],
    [USER_METHODS.DELETE, 'content-pages/:id'],
  ],
  organisation: [
    [USER_METHODS.POST, 'organisations'],
    [USER_METHODS.GET, 'organisations'],
    [USER_METHODS.PUT, 'organisations/:id'],
    [USER_METHODS.DELETE, 'organisations/:id'],
  ],
  businessType: [
    [USER_METHODS.POST, 'business-types'],
    [USER_METHODS.GET, 'business-types'],
    [USER_METHODS.PUT, 'business-types/:id'],
    [USER_METHODS.DELETE, 'business-types/:id'],
  ],
  centreType: [
    [USER_METHODS.POST, 'centre-types'],
    [USER_METHODS.GET, 'centre-types'],
    [USER_METHODS.PUT, 'centre-types/:id'],
    [USER_METHODS.DELETE, 'centre-types/:id'],
  ],
  masterCentres: [
    [USER_METHODS.POST, 'course-centres'],
    [USER_METHODS.GET, 'course-centres'],
    [USER_METHODS.PUT, 'course-centres/:id'],
    [USER_METHODS.DELETE, 'course-centres/:id'],
  ],
  pointsType: [
    [USER_METHODS.POST, 'points/get-points'],
    [USER_METHODS.GET, 'points/get-points'],
    [USER_METHODS.GET, 'points/:id'],
  ],
  demerit: [
    [USER_METHODS.POST, 'demerit-points'],
    [USER_METHODS.GET, 'demerit-points'],
  ],
  staffType: [
    [USER_METHODS.POST, 'staff-type'],
    [USER_METHODS.GET, 'staff-type/get-staff-types'],
    [USER_METHODS.PUT, 'staff-type/:id'],
    [USER_METHODS.POST, 'staff-type/get-staff-types'],
    [USER_METHODS.GET, 'staff-type/get-staff-type/:id'],
  ],
  demeritType: [
    [USER_METHODS.POST, 'demerit-points/create-demerit-Type'],
    [USER_METHODS.GET, 'demerit-points/get-demerit-types'],
    [USER_METHODS.PUT, 'demerit-points/update-demerit-Type/:id'],
    [USER_METHODS.GET, 'demerit-points/get-demerit-type/:id'],
  ],
  timesheetCentre: [
    [USER_METHODS.POST, 'centres'],
    [USER_METHODS.GET, 'centres'],
    [USER_METHODS.PUT, 'centres/:id'],
    [USER_METHODS.DELETE, 'centres/:id'],
  ],
  myTimesheet: [[USER_METHODS.GET, 'my-time-sheets']],
  schedule: [
    [USER_METHODS.POST, 'schedules'],
    [USER_METHODS.GET, 'schedules'],
    [USER_METHODS.PUT, 'schedules/:id'],
    [USER_METHODS.DELETE, 'schedules/:id'],
  ],
  mySchedule: [
    [USER_METHODS.GET, 'my-schedules'],
    [USER_METHODS.PUT, 'my-schedules/:id'],
    [USER_METHODS.DELETE, 'my-schedules/:id'],
  ],
  approve: [
    [USER_METHODS.GET, 'time-sheet-submissions'],
    [USER_METHODS.PUT, 'time-sheet-submissions/:id'],
    [USER_METHODS.DELETE, 'time-sheet-submissions/:id'],
  ],
  manageTimesheet: [
    [USER_METHODS.POST, 'time-sheets'],
    [USER_METHODS.GET, 'time-sheets'],
    [USER_METHODS.PUT, 'time-sheets/:id'],
    [USER_METHODS.DELETE, 'time-sheets/:id'],
  ],
  accountSettings: [
    [USER_METHODS.POST, 'settings'],
    [USER_METHODS.GET, 'settings'],
  ],
  systemLog: [
    [USER_METHODS.POST, 'logs/clean-log'],
    [USER_METHODS.GET, 'logs'],
  ],
  location: [
    [USER_METHODS.POST, 'locations'],
    [USER_METHODS.PUT, 'locations/:id'],
    [USER_METHODS.DELETE, 'locations/:id'],
  ],
  notification: [
    [USER_METHODS.POST, 'notifications'],
    [USER_METHODS.GET, 'notifications'],
    [USER_METHODS.PUT, 'notifications/:id'],
    [USER_METHODS.DELETE, 'notifications/:id'],
  ],
  zoom: [
    [USER_METHODS.GET, 'zooms'],
    [USER_METHODS.PUT, 'zooms/:id'],
    [USER_METHODS.DELETE, 'zooms/:id'],
  ],
  liveSessions: [[USER_METHODS.GET, 'user-events/get-events-live']],
  announcement: [
    [USER_METHODS.POST, 'announcements'],
    [USER_METHODS.GET, 'announcements'],
    [USER_METHODS.PUT, 'announcements/:id'],
    [USER_METHODS.DELETE, 'announcements/:id'],
  ],
  announcement: [
    [USER_METHODS.POST, 'announcements'],
    [USER_METHODS.GET, 'announcements'],
    [USER_METHODS.PUT, 'announcements/:id'],
    [USER_METHODS.DELETE, 'announcements/:id'],
  ],

  // businessRules: [
  //   [USER_METHODS.POST, 'announcements'],
  //   [USER_METHODS.GET, 'announcements'],
  //   [USER_METHODS.PUT, 'announcements/:id'],
  //   [USER_METHODS.DELETE, 'announcements/:id'],
  // ],
  reportLearningPath: [
    [USER_METHODS.GET, '/learning-path/reports/learning-path-reports'],
  ],
  reportUser: [[USER_METHODS.GET, 'reports/users']],
  reportCourse: [[USER_METHODS.GET, 'reports/courses']],
  reportTest: [[USER_METHODS.GET, 'report/get-report-test']],
  reportLive: [[USER_METHODS.GET, 'reports/get-course-liveclasses-reports']],
  reportAssignment: [[USER_METHODS.GET, 'report/get-report-assignment']],
  reportSurvey: [[USER_METHODS.GET, 'report/get-report-survey']],
  reportCertificate: [[USER_METHODS.GET, 'course-certificates/reports']],
  reportScorm: [[USER_METHODS.GET, 'report/get-report-scorm']],
  reportDemerit: [[USER_METHODS.GET, 'demerit-points']],
  reportCredits: [[USER_METHODS.GET, 'points']],
  reportAttendance: [
    [USER_METHODS.GET, 'classroom-sessions/:id'],
    [USER_METHODS.GET, 'user-courses/get-course-units'],
  ],
  reportGreatBook: [
    [USER_METHODS.GET, 'great-book'],
    [USER_METHODS.GET, 'great-book/:id'],
    [USER_METHODS.POST, 'great-book'],
    [USER_METHODS.PUT, 'great-book/:id/submit-approval'],
    [USER_METHODS.PUT, 'great-book/:id'],
    [USER_METHODS.POST, 'great-book/reports/:id'],
    [USER_METHODS.POST, 'great-book/reports'],
  ],
  reportStackable: [
    [USER_METHODS.GET, 'stackable'],
    [USER_METHODS.GET, 'stackable/view-progress'],
  ],
};

export const MANAGE_MENU = [
  {
    icons: <MdPersonOutline size={17} />,
    label: 'Users',
    countValue: 'users',
    pathUrl: '/users',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.user,
    activeStatus: userRoutePath,
    menuValue: 'users',
  },

  {
    icons: <MdOutlineGroup size={17} />,
    label: 'User Groups',
    countValue: 'userGroup',
    pathUrl: '/group',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.userGroups,
    activeStatus: userGroupRoutePath,
    menuValue: 'usergroups',
  },
  {
    icons: <MdOutlineBackupTable size={17} />,
    label: 'Courses',
    countValue: 'courses',
    pathUrl: '/course/courseGrid',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.course,
    activeStatus: courseRoutePath,
    menuValue: 'course',
  },
  {
    icons: <MdOutlineEditNote size={17} />,
    label: 'Classes',
    countValue: 'intakes',
    pathUrl: '/intakes/intake-grid',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.classes,
    activeStatus: intakeRoutePath,
    menuValue: 'classes',
  },
  {
    icons: <RiBankCardLine size={17} />,
    label: 'Content Approval',
    pathUrl: '/master/contentApproval',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    activeStatus: contentApprovalPath,
    userAccess: userAccessType.contentApproval,
    menuValue: 'contentapproval',
  },
  {
    icons: <MdOutlineCardMembership size={17} />,
    label: { learner: 'My Certificate', admin: 'Certificate' },
    pathUrl: { learner: '/certificate/userCertificate', admin: '/certificate' },
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
    ],
    userAccess: userAccessType.certificate,
    activeStatus: certificateRouthPath,
    menuValue: 'certificate',
  },
  {
    icons: <MdDoNotDisturbOnTotalSilence size={17} />,
    label: { learner: 'Demerit' },
    pathUrl: {
      learner: '/reports/demeritPoints/detailDemeritUser',
    },
    viewModeAccess: [USER_ROLES.LEARNER],
    userAccess: userAccessType.reportDemerit,
    activeStatus: demeritPointsRouthPath,
    menuValue: 'demeritLearner',
  },

  {
    icons: <MdOutlineCategory size={17} />,
    label: 'Categories',
    countValue: 'category',
    pathUrl: '/category',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.categories,
    activeStatus: categoryRouthPath,
    menuValue: 'categories',
  },
  // {
  //   icons: <MdOutlineClass size={17} />,
  //   label: 'Workshop',
  //   countValue: 'workshops',
  //   pathUrl: '/workshop',
  //   viewModeAccess: [
  //     USER_ROLES.ADMIN,
  //     USER_ROLES.SUPER_ADMIN,
  //     USER_ROLES.INSTRUCTOR,
  //     USER_ROLES.LEARNER,
  //   ],
  //   activeStatus: workshopRouthPath,
  // menuValue:'workshop'
  // },
  {
    icons: <MdImportExport size={17} />,
    label: 'Imports/Exports',
    pathUrl: '/import-export',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.importExport,
    activeStatus: importExportPath,
    menuValue: 'importexport',
  },
  {
    icons: <MdOutlineMonitor size={17} />,
    label: 'Monitoring',
    pathUrl: '/monitoring',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    userAccess: userAccessType.accountSettings,
    activeStatus: monitoringPath,
    menuValue: 'monitoring',
  },
  {
    icons: <MdOutlineBadge size={17} />,
    label: ' My Badge',
    pathUrl: '/Badge/badge',
    viewModeAccess: [USER_ROLES.LEARNER],
    activeStatus: userRoutePath,
    menuValue: 'mybadge',
  },
  {
    icons: <MdOutlineBadge size={17} />,
    label: 'Badge',
    pathUrl: '/Badge',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.badge,
    activeStatus: badgeRouthPath,
    menuValue: 'badge',
  },
  {
    icons: <MdOutlineAutoGraph size={17} />,
    label: 'Learning Path',
    pathUrl: '/learning-path',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
    ],
    userAccess: userAccessType.learningPath,
    activeStatus: learningRouthPath,
    menuValue: 'learningPath',
    // isSuperAdmin: true,
  },
  {
    icons: <BsPersonCheck size={17} />,
    label: 'Staff Request',
    pathUrl: '/staff-request',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.staffRequest,
    activeStatus: staffRequestRouthPath,
    menuValue: 'staffRequest',
  },
  {
    icons: <MdOutlineCardMembership size={17} />,
    label: 'Competency',
    pathUrl: '/reports/competency/isLearner',
    viewModeAccess: [USER_ROLES.LEARNER],
    userAccess: userAccessType.classes,
    activeStatus: reportCompetencyRoutePath,
    menuValue: 'competency',
  },
  {
    icons: <MdOutlineBackupTable size={17} />,
    label: 'Stackable Course',
    pathUrl: '/stackable-course',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.CENTRE_ADMIN,
    ],
    userAccess: userAccessType.learningPath,
    activeStatus: stackableCourseRoutePath,
    menuValue: 'stackableCourse',
  },
];
export const MASTER_MENU = [
  {
    icons: <MdOutlineRoomPreferences size={17} />,
    label: 'Organisation',
    pathUrl: '/master/organization',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.masterCentres,
    activeStatus: orgroutePath,
    menuValue: 'organization',
    // isSuperAdmin: true,
  },
  {
    icons: <MdOutlineBusinessCenter size={17} />,
    label: 'Business Type',
    pathUrl: '/master/businessType',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.masterCentres,
    activeStatus: businessPath,
    menuValue: 'bussinesstype',
    // isSuperAdmin: true,
  },
  {
    icons: <MdOutlineTravelExplore size={17} />,
    label: 'Centre Type',
    pathUrl: '/master/centreType',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.masterCentres,
    activeStatus: centreTypePath,
    menuValue: 'centretype',
    // isSuperAdmin: true,
  },
  {
    icons: <HiOutlineLocationMarker size={17} />,
    label: 'Centre',
    pathUrl: '/master/centres',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.masterCentres,
    activeStatus: centrePath,
    menuValue: 'centres',
  },
  {
    icons: (
      <svg
        className="creditsvgicon"
        xmlns="http://www.w3.org/2000/svg"
        height="17px"
        viewBox="0 -960 960 960"
        width="17px"
        fill="#3d5567 "
      >
        <path d="M480-304 304-480l176-176 176 176-176 176Zm56 199q-11 11-26 17t-30 6q-15 0-30-6t-26-17L105-424q-11-11-17-26t-6-30q0-15 6-30t17-26l318-318q12-12 26.5-18t30.5-6q16 0 30.5 6t26.5 18l318 318q11 11 17 26t6 30q0 15-6 30t-17 26L536-105Zm-56-87 288-288-288-288-288 288 288 288Z" />
      </svg>
    ),
    label: 'Credit',
    pathUrl: '/master/points',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.pointsType,
    activeStatus: pointsPath,
    menuValue: 'points',
  },

  {
    icons: <MdDoNotDisturbOnTotalSilence size={17} />,
    label: 'Demerit',
    pathUrl: '/master/demerit',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.demerit,
    activeStatus: demeritPath,
    menuValue: 'demerit',
  },
  {
    icons: <MdOutlineIndeterminateCheckBox size={17} />,
    label: 'Demerit Type',
    pathUrl: '/master/demeritType',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.demeritType,
    activeStatus: demeritTypePath,
    menuValue: 'demeritType',
  },
  {
    icons: <MdOutlineGroups size={17} />,
    label: 'Staff Type',
    pathUrl: '/master/staffType',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.staffType,
    activeStatus: staffTypePath,
    menuValue: 'staffType',
  },
  {
    icons: <MdOutlineManageAccounts size={17} />,
    label: 'Manage Staff Type',
    pathUrl: '/master/manageStaffType',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.manageStaffRequest,
    activeStatus: manageStaffTypePath,
    menuValue: 'manageStaffType',
  },
  {
    icons: <MdOutlineEditNotifications size={17} />,
    label: 'Reminder Master',
    countValue: 'reminders',
    pathUrl: '/reminder',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.announcement,
    activeStatus: reminderRouthPath,
    menuValue: 'reminder',
  },
  {
    icons: <RiUserSettingsLine size={17} />,
    label: 'Manage Staff Request',
    pathUrl: '/manage-staff-request',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.manageStaffRequest,
    activeStatus: manageStaffRequestRouthPath,
    menuValue: 'manageStaffRequest',
  },
  {
    icons: <Inbox size={17} />,
    label: 'Resource Master',
    pathUrl: '/master/resource',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.resourceMaster,
    activeStatus: resourceMasterRoutePath,
    menuValue: 'resourceMaster',
  },
  {
    icons: <MdOutlineRoom size={17} />,
    label: 'Location Master',
    pathUrl: '/master/location',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.locationMaster,
    activeStatus: locationMasterRoutePath,
    menuValue: 'locationMaster',
  },
  {
    icons: <GoPackage size={17} />,
    label: 'Competency',
    pathUrl: '/master/core-competencies',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.coreCompetencies,
    activeStatus: coreCompetenciesRoutePath,
    menuValue: 'coreCompetencies',
  },
  {
    icons: <AiOutlineCrown size={17} />,
    label: 'Level (Competency)',
    pathUrl: '/master/competency-mastery-levels',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.competencyMasteryLevels,
    activeStatus: competencyMasteryLevelsRoutePath,
    menuValue: 'competencyMasteryLevels',
  },
  {
    icons: <AiFillCrown size={17} />,
    label: 'Competency Level',
    pathUrl: '/master/competency-level',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.competencyLevels,
    activeStatus: competencyLevelsRoutePath,
    menuValue: 'competencyLevels',
  },
];
export const CMS_MENU = [
  {
    icons: <MdOutlineSettingsApplications size={17} />,
    label: 'CMS Settings',
    pathUrl: '/manageCmsBlog',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.cmsSettings,
    activeStatus: cmsSettingPath,
    menuValue: 'cmssetting',
  },
  {
    icons: <MdOutlineNoteAlt size={17} />,
    label: 'CMS Pages',
    pathUrl: '/lms-user/cmsBlog',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.cmsPages,
    activeStatus: cmsPagesRouthPath,
    menuValue: 'cmspage',
  },
];
export const TIMESHEET_MENU = [
  {
    icons: <MdControlCamera size={17} />,
    label: 'Centre Config',
    countValue: 'centres',
    pathUrl: '/centre',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.timesheetCentre,
    activeStatus: centerRouthPath,
    menuValue: 'centre',
  },
  {
    icons: <TbFileTime size={17} />,
    label: 'My Timesheet',
    pathUrl: '/timesheet/mytimesheet',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    activeStatus: myTimesheetRouthPath,
    userAccess: userAccessType.myTimesheet,
    menuValue: 'mytimesheet',
  },
  {
    icons: <MdOutlineToday size={17} />,
    label: 'Schedule',
    pathUrl: '/timesheet/schedule',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    activeStatus: scheduleRouthPath,
    userAccess: userAccessType.schedule,
    menuValue: 'schedule',
  },
  {
    icons: <MdOutlineEventAvailable size={17} />,
    label: 'My Schedule',
    pathUrl: '/timesheet/myschedule',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    activeStatus: myScheduleRouthPath,
    userAccess: userAccessType.mySchedule,
    menuValue: 'myschedule',
  },
  {
    icons: <TbFileCheck size={17} />,
    label: 'Approve',
    pathUrl: '/timesheet/approve',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    activeStatus: approveRouthPath,
    userAccess: userAccessType.approve,
    menuValue: 'approve',
  },
  {
    icons: <TbCalendarTime size={17} />,
    label: 'Manage Timesheet',
    pathUrl: '/timesheet/managetimesheet',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    activeStatus: manageTimesheetRouthPath,
    userAccess: userAccessType.manageTimesheet,
    menuValue: 'managetimesheet',
  },
];
export const SETTINGS_MENU = [
  {
    icons: <MdOutlineManageAccounts size={17} />,
    label: 'Account Settings',
    // pathUrl: '/setting-account',
    pathUrl: '/account-settings',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.accountSettings,
    activeStatus: settingsPath,
    menuValue: 'accountsetting',
    isSuperAdmin: true,
  },
  {
    icons: <MdOutlineSwitchAccount size={17} />,
    label: 'User Privileges',
    pathUrl: '/user-types',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.userType,
    activeStatus: usertypeRoutePath,
    menuValue: 'usertype',
  },
  {
    icons: <RiFileList2Line size={17} />,
    label: 'System Log',
    pathUrl: '/system-log',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.systemLog,
    activeStatus: systemLogPath,
    menuValue: 'systemLog',
  },
  {
    icons: <MdOutlineNotificationsNone size={17} />,
    label: 'Notification',
    pathUrl: '/notification',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.notification,
    activeStatus: notificationRouthPath,
    menuValue: 'notification',
  },
  {
    icons: <MdOutlineRoom size={18} />,
    label: 'Location',
    pathUrl: '/location',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.location,
    activeStatus: locationPath,
    menuValue: 'location',
  },
  {
    icons: <MdOutlineVideoCameraFront size={17} />,
    label: 'Zoom',
    pathUrl: '/zoom',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.zoom,
    activeStatus: zoomPath,
    menuValue: 'zoom',
  },
  {
    icons: <Target size={17} />,
    label: 'Online Sessions',
    pathUrl: '/live-sessions',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.liveSessions,
    activeStatus: liveSessionPath,
    menuValue: 'livesession',
  },
  {
    icons: <MdOutlineAnnouncement size={17} />,
    label: 'Announcement',
    countValue: 'announcements',
    pathUrl: '/announcement',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    userAccess: userAccessType.announcement,
    activeStatus: announcementRouthPath,
    menuValue: 'announcement',
  },

  // {
  //   icons: <BiBriefcase size={17} />,
  //   label: 'Business Rules',
  //   pathUrl: '/business-rules',
  //   viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
  //   userAccess: userAccessType.businessRules,
  //   activeStatus: businessRulesRouthPath,
  //   menuValue: 'businessRules',
  // },
];
export const REPORTS_MENU = [
  {
    icons: <AiOutlineBarChart size={17} />,
    label: 'Overview',
    pathUrl: '/reports',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    activeStatus: reportOverviewRouthPath,
    menuValue: 'reportoverview',
  },
  {
    icons: <RiFileUserLine size={17} />,
    label: 'Users',
    pathUrl: '/reports/users',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportUser,
    activeStatus: userReportRouthPath,
    menuValue: 'reportuser',
  },
  {
    icons: <MdOutlineLibraryBooks size={17} />,
    label: 'Classes',
    pathUrl: '/reports/courses',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportCourse,
    activeStatus: courseReportRouthPath,
    menuValue: 'reportcourse',
  },
  {
    icons: <FiTarget size={17} />,
    label: 'Online Class',
    pathUrl: '/reports/liveClass',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportLive,
    activeStatus: liveReportRouthPath,
    menuValue: 'Live',
  },
  {
    icons: <AiOutlineSchedule size={17} />,
    label: 'Online Class Calendar',
    pathUrl: '/reports/calandar',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportLive,
    activeStatus: liveReportScheduleRouthPath,
    menuValue: 'Live',
  },
  {
    icons: <MdOutlineSupervisorAccount size={17} />,
    label: 'Attendance',
    pathUrl: '/reports/attendance',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportAttendance,
    activeStatus: attendanceRouthPath,
    menuValue: 'attendance',
  },
  // {
  //   icons: <TbFileCheck size={17} />,
  //   label: 'Asynchronous Attendance',
  //   pathUrl: '/reports/asynchronous-attendance',
  //   viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
  //   userAccess: userAccessType.asynchronousAttendance,
  //   activeStatus: asynchronousAttendanceRoutePath,
  //   menuValue: 'asynchronousAttendance',
  // },
  {
    icons: <PenTool size={17} />,
    label: 'Tests',
    pathUrl: '/reports/tests',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportTest,
    activeStatus: testReportRouthPath,
    menuValue: 'test',
  },
  {
    icons: <MdOutlineAssignment size={17} />,
    label: 'Assignments',
    pathUrl: '/reports/assignments',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportAssignment,
    activeStatus: assignmentReportRouthPath,
    menuValue: 'assignment',
  },
  {
    icons: <Twitch size={17} />,
    label: 'Surveys',
    label: 'Surveys',
    pathUrl: '/reports/surveys',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportSurvey,
    activeStatus: surveyReportRouthPath,
    menuValue: 'survey',
  },
  {
    icons: <Inbox size={17} />,
    label: 'SCORM',
    pathUrl: '/reports/scorm',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportScorm,
    activeStatus: scormReportRouthPath,
    menuValue: 'scorm',
  },
  {
    icons: (
      <svg
        className="creditsvgicon"
        xmlns="http://www.w3.org/2000/svg"
        height="17px"
        viewBox="0 -960 960 960"
        width="17px"
        fill="#3d5567"
      >
        <path d="M480-304 304-480l176-176 176 176-176 176Zm56 199q-11 11-26 17t-30 6q-15 0-30-6t-26-17L105-424q-11-11-17-26t-6-30q0-15 6-30t17-26l318-318q12-12 26.5-18t30.5-6q16 0 30.5 6t26.5 18l318 318q11 11 17 26t6 30q0 15-6 30t-17 26L536-105Zm-56-87 288-288-288-288-288 288 288 288Z" />
      </svg>
    ),
    label: 'Credit',
    pathUrl: '/reports/credits/creditsGlobal',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportCredits,
    activeStatus: creditsPointsRouthPath,
    menuValue: 'credits',
  },
  {
    icons: <MdDoNotDisturbOnTotalSilence size={17} />,
    label: 'Demerit',
    pathUrl: '/reports/demeritPoints/demeritGlobal',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportDemerit,
    activeStatus: demeritPointsRouthPath,
    menuValue: 'demerit',
  },
  {
    icons: <MdOutlineAutoGraph size={17} />,
    label: 'Learning Path',
    pathUrl: '/reports/learning-path',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportLearningPath,
    activeStatus: learningReportRouthPath,
    menuValue: 'reportlearningpath',
  },
  {
    icons: <GoPackage size={17} />,
    label: 'Competency',
    pathUrl: '/reports/competency',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.asynchronousAttendance,
    activeStatus: reportCompetencyRoutePath,
    menuValue: 'asynchronousAttendance',
  },
  {
    icons: <MdOutlineCardMembership size={17} />,
    label: 'Certificate',
    pathUrl: '/certificate/certificateReport?report="Report"',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportCertificate,
    activeStatus: certificateReportRouthPath,
    menuValue: 'reportcertificate',
  },
  {
    icons: <MdOutlineManageAccounts size={17} />,
    label: 'Staff Type',
    pathUrl: '/reports/staffType',
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    userAccess: userAccessType.reportDemerit,
    activeStatus: StaffTypeReportRouthPath,
    menuValue: 'reportStaffTye',
  },
  {
    icons: <MdOutlineLibraryBooks size={17} />,
    label: 'Grade Book',
    pathUrl: '/reports/great-book/global-report',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.reportGreatBook,
    activeStatus: greatBookReportRouthPath,
    menuValue: 'reportGreatBook',
  },
  {
    icons: <MdOutlineLibraryBooks size={17} />,
    label: 'Stackable',
    pathUrl: '/reports/stackable',
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    userAccess: userAccessType.reportStackable,
    activeStatus: reportStackableRoutePath,
    menuValue: 'reportStackable',
  },
];

export const HEADER_MENU = [
  {
    name: 'Manage',
    label: <AiOutlineControl size={17} className="menu-header-icon" />,
    children: MANAGE_MENU,
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.LEARNER,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    activeStatus: userRoutePath,
    userAccess: [
      ...userAccessType.user,
      ...userAccessType.userType,
      ...userAccessType.userGroups,
      ...userAccessType.course,
      ...userAccessType.classes,
      ...userAccessType.contentApproval,
      ...userAccessType.categories,
      ...userAccessType.importExport,
      ...userAccessType.certificate,
      ...userAccessType.badge,
      ...userAccessType.staffRequest,
      ...userAccessType.learningPath,
    ],
    menuValue: 'manage',
  },
  {
    name: 'Master',
    label: <MdOutlinePsychology size={17} className="menu-header-icon" />,
    children: MASTER_MENU,
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.INSTRUCTOR,
      USER_ROLES.CENTRE_BL,
    ],
    activeStatus: userRoutePath,
    userAccess: [
      ...userAccessType.organisation,
      ...userAccessType.businessType,
      ...userAccessType.centreType,
      ...userAccessType.masterCentres,
      ...userAccessType.pointsType,
      ...userAccessType.manageStaffRequest,
      ...userAccessType.demerit,
      ...userAccessType.staffType,
    ],
    menuValue: 'master',
  },
  {
    name: 'CMS',
    label: <TbHeartRateMonitor size={17} className="menu-header-icon" />,
    children: CMS_MENU,
    viewModeAccess: [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN],
    activeStatus: userRoutePath,
    userAccess: [...userAccessType.cmsSettings, ...userAccessType.cmsPages],
    menuValue: 'cms',
  },
  {
    name: 'Timesheet',
    label: <MdOutlinePendingActions size={17} className="menu-header-icon" />,
    children: TIMESHEET_MENU,
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
    ],
    activeStatus: userRoutePath,
    userAccess: [
      ...userAccessType.timesheetCentre,
      ...userAccessType.myTimesheet,
      ...userAccessType.schedule,
      ...userAccessType.mySchedule,
      ...userAccessType.approve,
      ...userAccessType.manageTimesheet,
    ],
    menuValue: 'timesheet',
  },
  {
    name: 'Settings',
    label: <MdOutlineSettings size={17} className="menu-header-icon" />,
    children: SETTINGS_MENU,
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.INSTRUCTOR,
      // USER_ROLES.CENTRE_ADMIN,
    ],
    activeStatus: userRoutePath,
    userAccess: [
      ...userAccessType.accountSettings,
      ...userAccessType.systemLog,
      ...userAccessType.location,
      ...userAccessType.notification,
      ...userAccessType.zoom,
      ...userAccessType.liveSessions,
      ...userAccessType.announcement,
    ],
    menuValue: 'setting',
  },
  {
    name: 'Reports',
    label: <MdOutlineAssessment size={17} className="menu-header-icon" />,
    children: REPORTS_MENU,
    viewModeAccess: [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CENTRE_ADMIN,
      USER_ROLES.CENTRE_BL,
    ],
    activeStatus: userRoutePath,
    userAccess: [
      ...userAccessType.reportUser,
      ...userAccessType.reportCourse,
      ...userAccessType.reportTest,
      ...userAccessType.reportLive,
      ...userAccessType.reportAssignment,
      ...userAccessType.reportSurvey,
      ...userAccessType.reportCertificate,
      ...userAccessType.reportScorm,
      ...userAccessType.reportAttendance,
      ...userAccessType.reportLearningPath,
      ...userAccessType.reportGreatBook,
    ],
    menuValue: 'report',
  },
];
//CMS PATH

export const cmsPathName = [
  '/loginCms',
  '/homes/signup',
  '/homeCms',
  '/lms-user/home',
  '/course',
  '/homes/course',
  '/homes/myLearning',
  '/homes/intake',
  '/manageCmsBlog',
  '/lms-user/cmsBlog',
  '/lms-user/cmsBlog/testimonial',
  '/lms-user/cmsBlog/edit',
  '/lms-user/cmsBlog/view',
  '/lms-user/cart/wishList',
  '/lms-user/cart',
  '/lms-user/cart/checkout',
  '/lms-user/footer',
  '/lms-user/getstarted',
  '/homes/purchaseHistory',
  '/homes/purchaseHistory/invoice',
  '/homes/cart/wishList',
  '/homes/cart',
  '/homes/footer/aboutus',
  '/homes/footer/contactus',
  '/homes/footer/helpAndSupport',
  '/homes/footer/askus',
  '/homes/footer/overview',
  '/homes/footer/features',
  '/homes/footer/integration',
  '/homes/footer/privacypolicy',
  '/homes/footer/termsofservice',
  '/homes/footer/getstarted',
  '/homes/footer/mobileResponsive',
];
